// @flow
import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import Loudspeaker from '@cimpress-technology/react-loudspeaker';
import { withTranslation } from 'react-i18next';
import Shell from './components/application/Shell';
import { isProduction } from './utilities/processFunctions';
import HomePage from './components/home/HomePage';
import NotFound from './components/application/NotFound';
import AuthedRoute from './components/application/AuthedRoute';
import { auth } from './utils/auth';
import FullStory from './components/analytics/fullstory';
import SettingsPage from './components/settings/SettingsPage';
import ViewContractsPage from './components/contracts/viewTermRevision/ViewTermRevisionPage';
import theme from 'reapop-theme-wybo';
import MyNotificationsSystem from './components/application/notificationSystem';
import { connect } from 'react-redux';
import { selectors as notificationsSelectors } from './reducers/notifications';
import BulkUpdateWizard from './components/bulkUpdate/BulkUpdateWizard';
import ContractChangesPage from './components/contracts/contractChanges/ContractChangesPage';
import MainCreatePage from './components/contracts/MainCreatePage';
import ViewSkuPage from './components/contracts/viewSku/ViewSkuPage';
import LandingPage from './components/home/landingPage/LandingPage';
import BreadcrumbsEntry from './components/common/breadcrumbs/BreadcrumbsEntry';
import { CLAIM_USER_CANONICAL_ID } from './services/Coam';

class App extends React.Component {
  static propTypes = {
    isLoadingNotifications: PropTypes.bool
  };

  componentDidMount() {
    if (this.props.isLoadingNotifications) {
      window.addEventListener('beforeunload', this.onUnload);
    }
  }

  onUnload = e => {
    const confirmationMessage = this.props.t('common:unsavedChanges.message');

    (e || window.event).returnValue = confirmationMessage; //Gecko + IE
    return confirmationMessage;
  };

  componentDidUpdate(prevProps) {
    const { isLoadingNotifications } = this.props;

    if (isLoadingNotifications !== prevProps.isLoadingNotifications) {
      if (isLoadingNotifications) {
        window.addEventListener('beforeunload', this.onUnload);
      } else {
        window.removeEventListener('beforeunload', this.onUnload);
      }
    }
  }

  render() {
    const { t } = this.props;
    let story = null;
    let profile = auth.getProfile();
    if (!isEmpty(profile)) {
      const { name, email } = profile;
      const canonicalId = profile[CLAIM_USER_CANONICAL_ID]
      story = <FullStory org="97CT5" name={name} email={email} canonicalId={canonicalId} isProduction={isProduction} />;
    }
    let defaultTo = 'normalflow';
    const isRedirectedFromContractV2 = window.location.pathname.includes('&&!!');
    if (isRedirectedFromContractV2) {
      defaultTo = 'redirectionfromcontractv2';
    }
    return (
      <div>
        {story}
        <MyNotificationsSystem theme={theme} />
        <Loudspeaker
          title={t('appShell:loudspeakerModal.title')}
          accessToken={auth.getAccessToken()}
          channelId={isProduction ? 'ff-contractmanager-prd' : 'ff-contractmanager-stg'}
        />
        <Shell>{getData(defaultTo)}</Shell>
      </div>
    );
  }
}

const getData = defaultTo => {
  return defaultTo === 'normalflow' ? (
    <BreadcrumbsEntry title={{ translationKey: 'breadcrumbs:home' }} disableDefaults={true}>
      <Switch>
        <AuthedRoute exact path="/" component={LandingPage} />
        <AuthedRoute exact path="/(index.html)?" component={LandingPage} />
        <AuthedRoute path="/contracts" component={HomePage} />
        <AuthedRoute path="/create" component={MainCreatePage} />
        <AuthedRoute path="/bulkupdate" component={BulkUpdateWizard} />
        <AuthedRoute path="/configurations" component={SettingsPage} />
        <AuthedRoute path="/skus/:sku" component={ViewSkuPage} />
        <AuthedRoute path="/:id/:v2Key/changes" component={ContractChangesPage} />
        <AuthedRoute path="/:id/:revisionId/:v2Key?" component={ViewContractsPage} />
        <Route path="/*" component={NotFound} />
      </Switch>
    </BreadcrumbsEntry>
  ) : (
    <Switch>
      <AuthedRoute exact path="/" component={LandingPage} />
      <AuthedRoute exact path="/(index.html)?" component={LandingPage} />
      <AuthedRoute path="/contracts" component={HomePage} />
      <AuthedRoute path="/create" component={MainCreatePage} />
      <AuthedRoute path="/bulkupdate" component={BulkUpdateWizard} />
      <AuthedRoute path="/configurations/:v2Key?" component={SettingsPage} />
      <AuthedRoute path="/skus/:sku" component={ViewSkuPage} />
      <AuthedRoute path="/:id/:v2Key/changes" component={ContractChangesPage} />
      <AuthedRoute path="/:id/:revisionId/:v2Key?" component={ViewContractsPage} />
      <Route path="/*" component={NotFound} />
    </Switch>
  );
};

const mapStateToProps = state => ({
  isLoadingNotifications: notificationsSelectors.getHasLoadingNotifications(state)
});

export default connect(mapStateToProps)(withTranslation()(App));
